<template>
  <tr>
    <td :key="`item-icon-${item.id}`">
      <div class="icon">
        <svgicon :src="`icon/${item.type}.svg`" :width="16" :height="16"></svgicon>
      </div>
    </td>
    <td :key="`item-type-${item.id}`">{{ $t(`item_type.${item.type}`) }}</td>
    <td :key="`item-name-${item.id}`">{{ $to(item.name) }}</td>
    <td :key="`item-quantity-${item.id}`"><input type="number" v-model="item.qtyInStock" @keyup="setDirty(item)">
    </td>
    <td class="action" :key="`item-actions-${item.id}`" @click="open(item)">
      <svgicon src="icon/open-tab.svg" :width="16" :height="16"></svgicon>
    </td>
  </tr>
</template>

<script>
  export default {
    name: "StockEditRow",

    props: {
      item: Object
    },

    methods: {
      setDirty(item) {
        item.dirty = true;
      },
      open(item) {
        switch (item.type) {
          case "item":
            window.open(this.$router.buildContext("/#/item/edit", { item: item.id }), '_blank');
            break;
          case "variant":
            window.open(this.$router.buildContext("/#/item/edit", { item: item.parentId, variant: item.id }), '_blank');
            break;
          case "modifier":
            window.open(this.$router.buildContext("/#/modifiers/edit", { id: item.id }), '_blank');
            break;
          case "combo":
            window.open(this.$router.buildContext("/#/choice-items/edit", { id: item.id }), '_blank');
            break;
          case "supplement":
            window.open(this.$router.buildContext("/#/supplement/edit", { supplement: item.id }), '_blank');
            break;
        }
      }
    }
  };
</script>